import script from "./Links.vue?vue&type=script&setup=true&lang=ts"
export * from "./Links.vue?vue&type=script&setup=true&lang=ts"

import "./Links.vue?vue&type=style&index=0&id=4144d5d3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4144d5d3"]])

export default __exports__